import { gql } from '@apollo/client';

export const UPDATE_USER_FIELD = gql`
  mutation UpdateUserField($userId: Int, $value: String, $field: String) {
    updateUserField(userId: $userId, value: $value, field: $field) {
      id
    }
  }
`;
